import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    menuData: []
  },
  getters: {

  },
  mutations: {
    save_menuData (state, data) {
      state.menuData = data
    }
  },
  actions: {

  }
})
